import { Component, OnInit, Input } from '@angular/core';
import { MasterDataService } from '../masterdata/masterdata.service';
import { LabMDM, SelectableLab } from '../masterdata/models/lab';
import { OperetionHistoryDTO } from '../masterdata/models/operationHistory';
import { Station } from '../masterdata/models/station';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';

@Component({
  selector: 'app-mdm-station',
  templateUrl: './mdm-station.component.html',
  styleUrls: ['./mdm-station.component.css']
})
export class MdmStationComponent implements OnInit {

  @Input() masterLists: Station[];
  @Input() tableCols: any[];
  @Input() title: string;
  @Input() labOptions: LabMDM[];
  @Input() checkSelectedLab: SelectableLab;

  puid = localStorage.getItem('PUID');
  labOption: LabMDM[] = [];
  selectedMasterList: Station;
  popupTitle: string;
  displayMasterListDialog: boolean = false;
  errorHandler: ErrorHandler = new ErrorHandler;
  isNewMasterList: boolean;
  masterList: Station;
  selectedLabName: string;
  selectedLab: LabMDM;
  blocked: boolean = false;
  loading: boolean

  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService) { }

  ngOnInit() {}

  getActiveOptionsForDropdowns(): any {
    this.labOption=[];
    this._masterDataService.getLabs(true).subscribe(
      resultLabs => {
        if (!resultLabs) {
          return;
        }  
        let checkSelectedLabName = this.checkSelectedLab.lab.name;
        this.labOptions = resultLabs.data;
        this.labOptions.forEach(lab => {
          
          if(lab.name == checkSelectedLabName) {
            this.labOption.push(lab);
          }
          if (this.masterList && this.masterList.lab && lab._id == this.masterList.lab._id) {
            this.selectedLabName = this.masterList.lab.name;
            this.selectedLab = lab;
          }
        })
        this.labOptions= this.labOption;
        if (!this.masterList || !this.masterList.lab || this.selectedLabName != this.masterList.lab.name)
          this.selectedLab = null;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        }
    );
  }

  //Display Add Dialog upon clicking Add button
  showDialogToAddMasterList() {
    this.isNewMasterList = true;
    this.masterList = new Station;
    this.getActiveOptionsForDropdowns();
    this.displayMasterListDialog = true;
    this.selectedLab = null;
  }

  onRowSelect(event) {
    this.isNewMasterList = false;
    this.getActiveOptionsForDropdowns();
    this.masterList = this.cloneMasterList(event.data);
    this.displayMasterListDialog = true;
  }


  isSaveDisabled() {
    return !(this.masterList && this.masterList.name && this.selectedLab);
  }

  saveMasterListData() { 
    //in case the list not exists for the first time
    if(!this.masterLists){
      this.masterLists = [];
    }
    
    var labObj = new LabMDM();
    labObj._id = this.selectedLab._id;
    labObj.name = this.selectedLab.name;
    labObj.businessArea = this.selectedLab.businessArea;
    this.masterList.lab = labObj;
    this.appendHistory("Station");
    var inputData = JSON.stringify(this.masterList);
    
    if (this.isNewMasterList) {
      this.saveMasterData(inputData);
    }
    else {
      this.updateMasterData(inputData);
    }
  }
  private handleError(error: any) {
    this.blocked=false;
    let errorMessage = this.errorHandler.handleError(error);
    this._messageService.addErrorMessage(errorMessage);
  }

  //Inserts a new Template in DB
  saveMasterData(jsonString: string) {
    this.blocked=true;
    this._masterDataService.addStation(jsonString, this.selectedLab._id).subscribe(
      flowCellJson=> {
        if (!flowCellJson) {
          return;
        }
        this.displayMasterListDialog = false;
        this.masterList = flowCellJson.data;
        this.masterLists.push(this.masterList);
        this.masterList = null;
        this._messageService.addSuccessMessage({ severity: 'success', summary: 'Station created!', detail: 'New Station is created.' });
        this.blocked=false;
      },
      error => {
        this.handleError(error);
        }
    );
  }

  //Updates a Template in DB
  updateMasterData(jsonString: string) {

    this.blocked=true;
      this._masterDataService.updateStation(jsonString, this.selectedLab._id, this.selectedMasterList._id).subscribe(
        flowCellJson => {
          if (!flowCellJson) {
            return;
          }
          this.masterList = flowCellJson;
          this.masterLists[this.masterLists.indexOf(this.selectedMasterList)] = this.masterList;
          this.masterList = null;
          this._messageService.addSuccessMessage({ severity: 'success', summary: 'Updated Station!', detail: 'Station is Updated.' });
          this.displayMasterListDialog = false;
          this.blocked=false;
        },
        error => {
          this.handleError(error);
          }  
      );
    
    
  }

  cloneMasterList(list: any): any {
    let masterList = {};
    for (let prop in list) {
      masterList[prop] = list[prop];
    }
    return masterList;
  }

   //if a name not exist, the editing for that fiels is disabled
   isNameExists(fieldName) {
    if (this.masterList._id == null || this.masterList._id == '' ||  this.masterList._id == undefined) {
      return false;
    } else if (fieldName == "name") {
      return true;
    }
  }

  appendHistory(tabName: string){
    let historyObj:OperetionHistoryDTO = new OperetionHistoryDTO();
    historyObj.puid = this.puid;
    historyObj.operationDateTime = new Date();
    historyObj.tabName = tabName;
    if(this.masterList.history){
      this.masterList.history.push(historyObj);
    } else {
      this.masterList.history = [];
      this.masterList.history.push(historyObj);
    }
  }

}
